import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - CRITICAL UX FIX
 *
 * Automatically scrolls to top of page on route change.
 * Without this, users land in the middle/bottom of pages (CLUNKY).
 *
 * Must be placed inside Router but outside Routes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Primary target: the main scroll container (ID added to both layouts)
    const mainScrollContainer = document.getElementById('main-scroll-container');

    if (mainScrollContainer) {
      // Direct scroll - no animation
      mainScrollContainer.scrollTop = 0;
      mainScrollContainer.scrollLeft = 0;
    }

    // Also scroll window (for good measure)
    window.scrollTo(0, 0);

    // Use requestAnimationFrame as fallback to ensure it happens after render
    requestAnimationFrame(() => {
      if (mainScrollContainer) {
        mainScrollContainer.scrollTop = 0;
      }
      window.scrollTo(0, 0);
    });
  }, [pathname]);

  return null;
}
